// extracted by mini-css-extract-plugin
module.exports = {"page":"Onboarding_page__11KjY","hidden":"Onboarding_hidden__SgGPb","hide":"Onboarding_hide__3DtkX","spin":"Onboarding_spin__3ofxU"};